import React, { Component } from 'react';
import { colors } from 'themes/colors';

export default class DeveloperCard extends Component {
  render() {
    return (
      <div
        style={{
          overflow: 'hidden',
          borderRadius: '10px',
          background: '#fff',
          width: '70px',
          height: '110px',
          boxShadow: this.props.isDragging
            ? `0px 2px 6px ${colors.primary}`
            : '0px 2px 6px #333333da',
        }}
      >
        <img
          alt="profile"
          src={this.props.developer.source}
          style={{
            width: '100%',
            height: 'auto',
            right: 0,
            position: 'relative',
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DeveloperCard/DeveloperCard.js